import { AbilityBuilder } from "@casl/ability";

export default (user) => {
  const { can, cannot, rules } = AbilityBuilder.extract();

  if (!user.has_webui_access) {
    can("navigate", "logout");

    return rules;
  }

  switch (user.role) {
    case "superadmin":
      can("navigate", "all");

      can("switcher", "all");

      can("create", "all");
      can("update", "all");
      can("read", "all");
      can("delete", "all");

      can("revert", "all");
      break;

    case "admin":
      can("navigate", "all");

      can("switcher", "all");

      can("create", "jobs");
      can("update", "jobs");
      // can("update", "jobs", "is_recurring");
      // can("update", "jobs", "referred_by");
      // can("update", "jobs", "assigned_to");
      // can("update", "jobs", "customer");
      can("read", "jobs");
      // can("read", "jobs", "filter-by-technician");
      // can("read", "jobs", "reminders");
      // can("read", "jobs", "follow-ups");

      can("create", "appointments");
      // can("create", "appointments", "recurring");
      can("update", "appointments");
      // can("update", "appointments", "assign-others");
      // can("update", "appointments", "assistants");
      can("read", "appointments");

      can("create", "customers");
      can("update", "customers");
      can("read", "customers");

      can("update", "user");
      // can("update", "user", "brand-assignments");
      // can("update", "user", "types");
      // can("update", "user", "emergency-contacts");
      // can("update", "user", "documents");
      // can("update", "user", "work-areas");
      // can("update", "user", "unavailabilities");
      // can("update", "user", "brandings");
      // can("update", "user", "activities");
      can("read", "user");
      // can("read", "user", "not-owned-users");

      can("read", "availabilities");
      // can("read", "availabilities", "full-mode");
      // can("read", "availabilities", "filter-by-brand");
      // can("read", "availabilities", "filter-by-state");

      can("read", "invoices");

      can("read", "header-accepted-quotes");
      can("read", "header-reminders");
      can("read", "footer-nag-bars");

      if (user?.designation?.brand_mentor) {
        cannot("navigate", "tributes");
        cannot("navigate", "vouchers");
        cannot("navigate", "orgchart");
        cannot("navigate", "brands");
      }

      if (user?.designation?.no_access_to_invoices) {
        cannot("read", "header-accepted-quotes");
        cannot("navigate", "invoices");
        cannot("read", "invoices");
      }
      break;

    case "manager":
      // Navigate object users both singular and plural
      can("navigate", "dashboard");
      can("navigate", "work");
      can("navigate", "jobs");
      can("navigate", "admin");
      can("navigate", "users");
      can("navigate", "dash");
      can("navigate", "mapit");
      can("navigate", "logout");

      can("switcher", "all");

      can("create", "jobs");
      can("update", "jobs");
      can("read", "jobs");

      can("create", "appointments");
      can("update", "appointments");
      can("read", "appointments");

      can("create", "customers");
      can("update", "customers");
      can("read", "customers");

      can("read", "invoices");

      can("update", "user");
      can("read", "user");

      can("read", "availabilities");

      break;

    case "technician":
      can("navigate", "dashboard");
      can("navigate", "work");
      can("navigate", "jobs");
      can("navigate", "invoices");
      can("navigate", "logout");

      cannot("navigate", "media");

      can("switcher", "bolt");
      can("switcher", "dash");

      can("read", "invoices");

      if (
        user?.designation?.restricted_to_brands ||
        user?.designation?.restricted_to_state_brands
      ) {
        can("read", "user");

        can("create", "jobs");
        can("update", "jobs");
        can("read", "jobs");

        can("read", "availabilities");
        cannot("read", "availabilities", "filter-by-brand");
        cannot("read", "availabilities", "filter-by-state");

        can("create", "appointments");
        can("update", "appointments");
        can("read", "appointments");

        can("navigate", "customers");
        can("create", "customers");
        cannot("create", "customers", "without-job-context");
        can("update", "customers");
        can("read", "customers");
        cannot("read", "customers", "filter-by-brand");

        cannot("update", "jobs", "customer");

        cannot("read", "invoices", "filter-by-brand");

        can("read", "footer-nag-bars");
      }

      if (user?.designation?.agency_access) {
        cannot("navigate", "work");
        cannot("navigate", "jobs");

        can("navigate", "media");

        can("read", "availabilities", "full-mode");
        cannot("read", "availabilities", "scrutiny-lock");

        can("read", "availabilities", "filter-by-brand");
        can("read", "availabilities", "filter-by-state");
      }

      if (user?.designation?.no_access_to_invoices) {
        cannot("read", "header-accepted-quotes");
        cannot("navigate", "invoices");
        cannot("read", "invoices");
      }
      break;

    default:
      can("navigate", "logout");
  }

  return rules;
};
